import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCheckboxChecked$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCheckboxChecked extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'eca406b28ab09eec4d6929b7200e44d70b837a6e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '496530ac2c115aa5a65316a9776750c96c89ac97', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '874d6fe1cd18fdbe0fe4ab2278fc11dff910d077', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5zm14 1.5v13h-13v-13zM7.12 11.37 10 14.2a.49.49 0 0 0 .69-.03l4.7-5.58a.49.49 0 0 0-.06-.7l-.38-.32a.48.48 0 0 0-.7.06l-4 4.74-2.07-2.06a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-checkbox-checked", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-checkbox-checked"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-checkbox-checked":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCheckboxChecked$1);
            }
            break;
    } });
}

const CosmosIconCheckboxChecked = CosmosIconCheckboxChecked$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCheckboxChecked, defineCustomElement };
